import React from "react";

import './style.scss';
import {getThemeClasses} from "@common-helpers/get-theme-classes";
import {Button} from "@common-ui/btn";

export const Modal = ({
    theme, children, isOpen, openHandler
}) =>
{
    const closeModalHandler = () => {
        openHandler(false);
    }

    document.addEventListener('click', (event) => {
        const target = event.target;

        if (isOpen && !target.closest('.modal__inner')) {
            closeModalHandler();
        }
    });

    let text = 'Понятно',
    language = localStorage.getItem('lang')

    if(language === 'eng'){
        text = 'OK'
    } else if(language === 'ger'){
        text = 'klar'
    } else if(language === 'fr'){
        text = 'dégager'
    } else if(language === 'it'){
        text = 'chiaro'
    }

    return (
        <div className={getThemeClasses({baseClass: 'modal', theme})+`${isOpen?' modal_open':''}`}>
            <div className={'modal__inner'}>
                <div dangerouslySetInnerHTML={{__html: children}}/>
                <Button onClick={closeModalHandler} theme={'modal'}>
                    {text}
                </Button>
            </div>
        </div>
    )
}